module.exports = __webpack_public_path__ + "img/shareScripsWhite.6a84f38b.svg";